import { global } from "@/global";
import { isLogin } from '@/router/_auth';

export default {
	path: '/login',
	name: 'login',
	meta: {
		menu: false,
	},
	beforeEnter: (to, from, next) => {
		if (isLogin()) {
			next({
				name: global["HOMEPAGE"]
			})
		} else next();
		return;
	},
	component: () => import(/* webpackChunkName: "login" */ '../views/login/Login.vue'),
}